import { useMemo } from 'react'
import type { LayerProps, SymbolLayer } from 'react-map-gl'
import { PROPERTY_TYPES_COLORS } from '~/constants'

export function useListingPointLayerStyle(props: Partial<SymbolLayer> = {}) {
  const layerCaseStyles = useMemo(() => {
    const cases: any = []
    cases.push(['==', ['get', 'featured'], true], 'featured')

    const types = ['lease', 'sale', 'sale-lease']
    PROPERTY_TYPES_COLORS.forEach(({ value, propertyType }) => {
      types.forEach((type) => {
        cases.push(
          ...[
            [
              'all',
              ['==', ['get', 'imageType'], type],
              ['==', ['get', 'primaryPropertyType'], propertyType],
            ],
            `${value}-${type}`,
          ]
        )
      })
    })
    return cases
  }, [])

  const pointLayer: LayerProps = {
    ...props,
    type: 'symbol',
    layout: {
      'icon-image': [
        'case',
        ...layerCaseStyles,

        // default
        'red-sale-lease',
      ],
      'icon-size': ['match', ['get', 'type'], 'lease', 0.085, 0.085],
      'icon-allow-overlap': true,
    },
  }
  return pointLayer
}
